import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';

import * as actions from '@redux/actions/productReview';
import * as productReviewTypes from '@redux/actions/productReview/productReviewTypes';
import { getAsObservable } from '@services/genericService';
import { deepCopy } from '@utils/utility';

import * as config from './config';

export const getDynamicBundleElementEpic = (action$) =>
  action$.pipe(
    ofType(productReviewTypes.GET_DYNAMIC_BUNDLE_ELEMENT),
    switchMap((action) => {
      const params = {
        bundlePageId: action.payload.bundlePageId,
      };

      return getAsObservable(config.ACTION_GET_DYNAMIC_BUNDLE_ELEMENT, params).pipe(
        map((res) => {
          if (res.status === 200) {
            return actions.getDynamicBundleElementSuccess(deepCopy(res.data));
          } else {
            return actions.getDynamicBundleElementFailed('Failed');
          }
        })
      );
    })
  );
